// THE ACTIVITY FILTER - any level, and everything below it.
//
// Owner, 2026-10-15: "allow all parents and children to be used in advanced
// filters, at all levels, and including all children of any parent
// recursively if filter selected a parent, both for shop drawings filter,
// issue manager filter, contractor cost filter".
//
// The schedule's own tree (components/Coordination/ActivityPicker's
// buildActivityTree, under its BIM / Field / Management lanes). Several rows
// may be picked; the SERVER widens each pick to every row below it
// (utils/activitySubtree), so the value stays the rows a person chose and a
// saved filter keeps meaning "Level 1" even after rows are added under it.
//
// Held as "id,id" - the same ?ganttItemId= the list, the exports, the saved
// filters and the cost report carry.
//
//   <ActivityFilterSelect projectId={pid} value="a,b" onChange={(v) => ...} />
import React, { useEffect, useMemo, useState } from "react";
import { TreeSelect } from "antd";
import { listGanttItems } from "api/gantt/ganttApi";
import { buildActivityTree } from "./ActivityPicker";

export default function ActivityFilterSelect({ projectId, value, onChange, style, size, placeholder = "Activity" }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    if (!projectId) { setItems([]); return undefined; }
    Promise.resolve()
      .then(() => listGanttItems(projectId))
      .then((res) => { if (alive) setItems(Array.isArray(res) ? res : (res && res.items) || []); })
      .catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, [projectId]);
  const tree = useMemo(() => buildActivityTree(items), [items]);
  const picked = value ? String(value).split(",").filter(Boolean) : [];
  return (
    <TreeSelect
      multiple allowClear showSearch size={size}
      aria-label="Activity filter"
      maxTagCount="responsive"
      disabled={!projectId}
      style={{ minWidth: 220, maxWidth: 340, ...(style || {}) }}
      dropdownStyle={{ maxHeight: 440, overflow: "auto", minWidth: 380 }}
      popupMatchSelectWidth={false}
      treeNodeFilterProp="searchText"
      treeNodeLabelProp="label"
      placeholder={projectId ? placeholder : `${placeholder} - pick a project`}
      title="Pick any row - a level, an area, a stage or one activity. A row brings everything below it."
      value={picked}
      onChange={(v) => onChange && onChange((v || []).filter((x) => !String(x).startsWith("lane:")).join(","))}
      treeData={tree}
      notFoundContent={projectId ? "No activities on this project's schedule" : "Pick a project first"}
    />
  );
}
